import React from "react";
import "./styles/_main.scss";
import { SpeeltuinProvider } from "./store/Store";
import SpeeltuinchefRoute from "./route/SpeeltuinchefRoute";

function App() {
  return (
    <SpeeltuinProvider>
      <SpeeltuinchefRoute />
    </SpeeltuinProvider>
  );
}

export default App;
